<template>
    <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><g class="filled" fill="none" fill-rule="evenodd"><g fill="#f26363"><path d="m11 0h2v24h-2z"/><path d="m11 0h2v24h-2z" transform="matrix(0 -1 1 0 0 24)"/></g></g></svg>
</template>
